<template>
    <div class="row">
        <div class="col-12 mb-1">
            <h5 v-show="!$func.isEmpty(nomeSolicitante)" style="font-size: 1.2rem;">Olá, {{ $func.ucWords(nomeSolicitante) }}</h5>
            Acompanhe seu atendimento
        </div>
        <h6 class="col-12 mb-0">Dados do atendimento</h6>
        <div class="col-7">
            <span class="h6 m-0">Protocolo:</span> {{ protocolo }}
        </div>
        <div class="col-5">
            <span class="h6 m-0">Data:</span> {{ data }}
        </div>
        <div class="col-12">
            <span class="h6">
                Motivo<span v-if="exibeServico">/Serviço</span>:
            </span> 
            {{ motivoServico() }}
        </div>
        <div class="col-6"><span class="h6">Placa:</span> {{ placa }}</div>
        <div class="col-12">
            <span class="h6">Modelo:</span>
            {{ modeloMontadora() | truncate(this.tamanhoString, '...') }}
            <button type="button" 
                class="btn btn-default btn-sm" 
                v-b-tooltip.click.top="modeloMontadora()"
                :title="modeloMontadora()"
                v-if="modeloMontadora().length >= this.tamanhoString"
            >
                <i class="fa fa-eye fa-sm" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            strMotivoServico: ''
        }
    },
    props: {
        nomeSolicitante: String,
        protocolo: String,
        data: String,
        motivo: Object,
        servicos: [Object, Array],
        placa: String,
        modelo: String,
        montadora: String,
    },
    computed: {
        exibeServico() {
            return Object.keys(this.servicos).length == 1;
        },
        tamanhoString() {
            let total = 5 * window.screen.availWidth / 100;
            if (total > 20) {
                total = 20;
            }
            return parseInt(total);
        }
    },
    methods: {
        motivoServico() {
            if (this.$func.isEmpty(this.motivo.descricao)) {
                return "Não informado";
            }

            let strServico = "";
            if (this.exibeServico && !this.$func.isEmpty(this.servicos)) {
                strServico = " / " + this.servicos[Object.keys(this.servicos)[0]].descricao;
            }

            return this.$func.ucWords(this.motivo.descricao +  strServico);
        },

        modeloMontadora() {
            if (
                !this.$func.isEmpty(this.modelo) &&
                !this.$func.isEmpty(this.montadora)
            ) {
                return this.$func.ucWords(this.modelo + " / " + this.montadora);
            }

            if (!this.$func.isEmpty(this.montadora)) {
                return this.$func.ucWords(this.montadora);
            }

            if (!this.$func.isEmpty(this.montadora)) {
                return this.$func.ucWords(this.montadora);
            }

            return "Não informado";
        },
    }
};
</script>
